"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getDataDropdownPos = exports._getDataDropdownArea = exports._getGridRfidLog = void 0;
const axios_1 = __importDefault(require("axios"));
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const _getGridRfidLog = ({ skip, take, filter }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/adjustment/rfid';
        const filterString = filter ? JSON.stringify(filter) : undefined;
        const config = {
            params: { skip, take, filter: filterString },
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        };
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getGridRfidLog = _getGridRfidLog;
const _getDataDropdownArea = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/master-data/enum';
        const sort = [{ field: 'value', dir: 'desc' }];
        const filter = {
            logic: 'and',
            filters: [
                { field: 'is_active', operator: 'eq', value: true },
                { field: 'type', operator: 'contains', value: 'Checkpoint Type' }
            ]
        };
        const config = {
            params: {
                skip: 0,
                take: 100,
                sort: JSON.stringify(sort),
                filter: JSON.stringify(filter)
            },
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        };
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { isError, errorCode, errorMessage } = (0, error_response_1.errorResponse)(e);
        return {
            data: [],
            isError,
            errorCode,
            errorMessage,
        };
    }
});
exports._getDataDropdownArea = _getDataDropdownArea;
const _getDataDropdownPos = ({ checkpoint_type_id }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/master-data/checkpoint-type';
        const sort = [{ field: 'description', dir: 'asc' }];
        const filter = {
            logic: 'and',
            filters: [
                { field: 'is_active', operator: 'eq', value: true },
                { field: 'checkpoint_type_id', operator: 'uuid', value: checkpoint_type_id }
            ]
        };
        const config = {
            params: {
                skip: 0,
                take: 100,
                sort: JSON.stringify(sort),
                filter: JSON.stringify(filter)
            },
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        };
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { isError, errorCode, errorMessage } = (0, error_response_1.errorResponse)(e);
        return {
            data: [],
            isError,
            errorCode,
            errorMessage,
        };
    }
});
exports._getDataDropdownPos = _getDataDropdownPos;
